var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithoutCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "MuiSvgIconroot-0-2-80 makeStylesstrokeIcon-0-2-78 MuiSvgIconcolorPrimary-0-2-81 MuiSvgIconfontSizeLarge-0-2-88",
    focusable: "false",
    viewBox: "0 0 38 38",
    role: "img",
    "aria-label": "components.directives.element-image.element-image-accessibility.img-icon-calculation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "transparent",
    fillRule: "evenodd",
    d: "M0 1c0-.5523.4477-1 1-1h36c.5523 0 1 .4477 1 1v36c0 .5523-.4477 1-1 1H1c-.5523 0-1-.4477-1-1V1zm2 1v16h16V2H2zm18 0v16h16V2H20zm16 18H20v16h16V20zm-18 0H2v16h16V20zM10 5c.5523 0 1 .4477 1 1v3h3c.5523 0 1 .4477 1 1s-.4477 1-1 1h-3v3c0 .5523-.4477 1-1 1s-1-.4477-1-1v-3H6c-.5523 0-1-.4477-1-1s.4477-1 1-1h3V6c0-.5523.4477-1 1-1zm13 5c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-8c-.5523 0-1-.4477-1-1zM5.2929 24.7071c-.3905-.3905-.3905-1.0237 0-1.4142.3905-.3905 1.0237-.3905 1.4142 0L10 26.5858l3.2929-3.2929c.3905-.3905 1.0237-.3905 1.4142 0 .3905.3905.3905 1.0237 0 1.4142L11.4142 28l3.2929 3.2929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L10 29.4142l-3.2929 3.2929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L8.5858 28l-3.293-3.2929zM23 26c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-8c-.5523 0-1-.4477-1-1zm0 4c0-.5523.4477-1 1-1h8c.5523 0 1 .4477 1 1s-.4477 1-1 1h-8c-.5523 0-1-.4477-1-1z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithoutCategory);
export default __webpack_public_path__ + "static/media/without_category.c301dad7310e98e719bb986091dd78c2.svg";
export { ForwardRef as ReactComponent };